export const HttpStatus = {
  Forbidden: 403,
  UnprocessableEntity: 422,
};
